package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

// Función para codificar un JSON a Base64
@OptIn(ExperimentalEncodingApi::class)
fun String.encodeToBase64(): String {
    return Base64.encode(this.encodeToByteArray(), 0, this.length)
}

// Función para decodificar Base64 a JSON
@OptIn(ExperimentalEncodingApi::class)
fun String?.decodeFromBase64(): String? {
    if (this == null) return null
    try {
        return Base64.decode(this).decodeToString()
    } catch (e: Exception) {
        e.printStackTrace()
        return null // La cadena Base64 es incorrecta
    }
}

fun String?.isValidEmail(): Boolean {
    val emailRegex = "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,6}$"
    return this != null && this.matches(emailRegex.toRegex())
}

fun String?.isValidInt(): Boolean {
    if (this == null) return false
    val normalizedText = this.trim()    // 1. Normalizar la cadena: eliminar espacios en blanco al inicio y al final
    val positiveIntegerRegex = "^\\d+$".toRegex() // Regex para entero positivo (solo dígitos, al menos uno)
    return normalizedText.matches(positiveIntegerRegex)
}

fun generateOTP(): Int {
    return (100000..999999).random()
}

fun String?.isValidPassword(): Pair<Boolean,String?> {
    return if (this.isNullOrEmpty()) {
        Pair(false,"La contraseña no puede estar vacía.")
    } else {
        if (this.length < 8) {
            Pair(false,"La contraseña debe tener al menos 8 caracteres.")
        } else
        if (!this.matches(".*[0-9].*".toRegex())) { // Regex para al menos un dígito (usando [0-9])
            Pair(false,"La contraseña debe tener al menos un número.")
        } else
        if (!this.matches(".*[A-Z].*".toRegex())) { // Regex para al menos una mayúscula
            Pair(false,"La contraseña debe tener al menos una letra mayúscula.")
        } else
        Pair(true,null)
    }


}

fun String?.isValidName(): Boolean {
    // 1. Normalizar espacios: eliminar al inicio/final y reducir múltiples espacios a uno solo
    val normalizedName = this.orEmpty().trim().replace("\\s+".toRegex(), " ")

    // 2. Verificar longitud mínima (después de normalizar)
    if (normalizedName.length < 3) { // Ajusta este valor si lo consideras necesario
        return false
    }

    // 3. Verificar que la cadena normalizada solo contenga letras y espacios
    for (char in normalizedName) {
        if (!char.isLetter() && !char.isWhitespace()) {
            return false // Carácter inválido encontrado después de normalizar
        }
    }

    // 4. Verificar que contenga al menos 2 palabras (después de normalizar)
    val words = normalizedName.split("\\s+".toRegex()) // Dividir la cadena normalizada por espacios
    if (words.size < 2) {
        return false // No tiene al menos 2 palabras después de normalizar
    }

    // 5. Verificar que ninguna palabra esté vacía después de dividir (tras normalización)
    for (word in words) {
        if (word.isEmpty()) {
            return false // Palabra vacía encontrada tras normalización, indica problema de formato
        }
    }

    return true // Cumple todos los criterios después de la normalización
}